<template>
    <div>
      <div class="register">
        <div class="list">
          <ul>
            <li v-for="item in downLaodLists" :key="item.index">
              <el-link :href="item.link" target="_blank">{{ item.name }}</el-link>
            </li>
          </ul>
          <div class="downloadIcon">报名链接</div>
        </div>
      </div>
    </div>
  </template>
    
<script>
  export default {
    name: "register",
    data() {
      return {
        downLaodLists: [
          {
            name: "报名链接",
            // name2: "tianxinqu",
            link: "http://rxbm.csedu.gov.cn/",
          },
        //   {
        //     name: "芙蓉区",
        //     name2: "furongqu",
        //     link: "https://hunan.tianditu.gov.cn/TDTHN/portal/xuequ2023/pdf/furongqu.pdf",
        //   },
        //   {
        //     name: "开福区",
        //     name2: "kaifuqu",
        //     link: "https://hunan.tianditu.gov.cn/TDTHN/portal/xuequ2023/pdf/kaifuqu.pdf",
        //   },
        //   {
        //     name: "湘江新区",
        //     name2: "xiangjiangxinqu",
        //     link: "https://hunan.tianditu.gov.cn/TDTHN/portal/xuequ2023/pdf/xiangjiangxinqu.pdf",
        //   },
        //   {
        //     name: "雨花区",
        //     name2: "yuhuaqu",
        //     link: "https://hunan.tianditu.gov.cn/TDTHN/portal/xuequ2023/pdf/yuhuaqu.pdf",
        //   },
        //   {
        //     name: "望城区",
        //     name2: "wangchengqu",
        //     link: "https://hunan.tianditu.gov.cn/TDTHN/portal/xuequ2023/pdf/wangchengqu.pdf",
        //   },
        ],
      };
    },
    methods: {},
  };
  </script>
    
  <style scoped lang="scss">
  .register {
    position: absolute;
    top: 59%;
    left: 0;
    z-index: 9999;
    transform: translateY(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      .list {
        margin-left: 0;
      }
    }
    .list {
      transition: all 0.5s;
      width: 70px;
      height: 65px;
      position: relative;
      padding: 10px;
      background-color: #fff;
      box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);
      margin-left: -90px;
      ul {
        padding: 0;
        margin: 7px;
        list-style: none;
        line-height: 35px;
      }
      .downloadIcon {
        padding: 10px 0;
        width: 30px;
        height: 65px;
        writing-mode: vertical-lr;
        line-height: 25px;
        position: absolute;
        top: 50%;
        right: -30px;
        z-index: 9999;
        transform: translateY(-50%);
        background-color: #409eff;
        color: #fff;
      }
    }
  }
  </style>
    